<div class="d-flex-column widget-border widget-layout-large widget-content">
    <div class="widget-header">
        <div class="widget-header-clickable" (click)="navigate()">
            <h2 *ngIf="titleT">{{ titleT | translate }}</h2>
            <div *ngIf="showItemsCount" class="widget-badge">
                <span>{{ itemsCount }}</span>
            </div>
            <a *ngIf="navigateLink" mat-icon-button [routerLink]="navigateLink">
                <mat-icon svgIcon="arrow_right" color="accent"></mat-icon>
            </a>
        </div>
        <div class="pull-right">
            <ng-content select=".slot-action-button"></ng-content>
        </div>
    </div>

    <app-widget-selector-spinner *ngIf="selectorToWaitFor" [selectorToWaitFor]="selectorToWaitFor!" [ignoreWasPending]="true" />
    <app-widget-spinner *ngIf="loading" [loading]="loading" />
    <ng-content></ng-content>
    <div class="widget-footer">
        <ng-content select=".slot-footer"></ng-content>
    </div>
</div>